import { render, staticRenderFns } from "./listhives.vue?vue&type=template&id=ac445c06&"
import script from "./listhives.vue?vue&type=script&lang=js&"
export * from "./listhives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports